// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router, ensureDynamicRoutes } from './router/index'
import antDesignVue from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './styles/drs-list.scss'
import i18n from './local'
import store from './store'
import EllipsisTable from './components/EllipsisTable/index.vue'
import DeleteConfirm from './components/DeleteConfirm/index.vue'
import PermissionDirective from './directives/permission'
import { bindSchoolStore, getCurrentSchoolInfo } from './utils/schoolContext'
import loginBgUrl from './assets/login_bg.png'
import logoUrl from './assets/logo.png'

Vue.use(antDesignVue)
Vue.use(PermissionDirective, store)
Vue.component('EllipsisTable', EllipsisTable)
Vue.component('DeleteConfirm', DeleteConfirm)

bindSchoolStore(store)
Vue.prototype.imageHost = process.env.VUE_APP_IMGURL
Vue.prototype.importTemplateHost = (process.env.VUE_APP_IMGURL || '').replace(/\/$/, '')
Vue.prototype.$currentSchoolInfo = getCurrentSchoolInfo
Vue.prototype.$currentSchoolId = function() {
  return getCurrentSchoolInfo().schoolId || ''
}

const loadingStartTime = window.__APP_LOADING_START__ || Date.now()
const minLoadingDuration = 2000
const maxPreloadWait = 2600
const loadingElapsed = Date.now() - loadingStartTime
const currentPath = `${window.location.pathname || ''}${window.location.hash || ''}`
const skipMinLoading = /(^|#)\/404(?:[/?#]|$)/.test(currentPath)
const mountDelay = skipMinLoading ? 0 : Math.max(0, minLoadingDuration - loadingElapsed)

function preloadImage(src) {
  return new Promise(resolve => {
    if (!src) {
      resolve()
      return
    }
    const image = new Image()
    image.onload = resolve
    image.onerror = resolve
    image.src = src
  })
}

function getStartupPath() {
  const hash = window.location.hash || ''
  if (!hash || hash === '#') return '/'
  return hash.replace(/^#/, '') || '/'
}

function getToken() {
  return localStorage.getItem('token') || ''
}

function preloadAsyncComponent(component) {
  if (!component || typeof component !== 'function') return Promise.resolve()
  return new Promise(resolve => {
    component(() => resolve())
  }).catch(() => {})
}

function preloadMatchedRoute(path) {
  const matchedRoute = router.match(path || '/')
  const records = matchedRoute && matchedRoute.matched ? matchedRoute.matched : []
  return Promise.all(records.map(record => {
    const components = record.components || {}
    return preloadAsyncComponent(components.default || record.component)
  }))
}

function withTimeout(promise, timeout) {
  return new Promise(resolve => {
    const timer = window.setTimeout(resolve, timeout)
    Promise.resolve(promise).then(() => {
      window.clearTimeout(timer)
      resolve()
    }).catch(() => {
      window.clearTimeout(timer)
      resolve()
    })
  })
}

function preloadLoginResources() {
  return Promise.all([
    preloadImage(loginBgUrl),
    preloadImage(logoUrl),
    preloadMatchedRoute('/login')
  ])
}

function preloadStartupResources() {
  const startupPath = getStartupPath()
  const token = getToken()
  if (!token) {
    return withTimeout(preloadLoginResources(), maxPreloadWait)
  }
  return withTimeout(
    store.dispatch('loadUserMenus').then(() => {
      ensureDynamicRoutes()
      return Promise.all([
        preloadImage(logoUrl),
        preloadMatchedRoute(startupPath)
      ])
    }).catch(() => preloadLoginResources()),
    maxPreloadWait
  )
}

function mountApp() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    store: store,
    components: {App},
    template: '<App/>'
  })
}

Promise.all([
  new Promise(resolve => window.setTimeout(resolve, mountDelay)),
  skipMinLoading ? Promise.resolve() : preloadStartupResources()
]).then(mountApp)



// WEBPACK FOOTER //
// ./src/main.js